import PropTypes from 'prop-types';
import sha1 from '@republic/foundation/crypto/sha1';
import {updated} from '@republic/foundation/http/query';
import {reduce} from '@republic/foundation/lang/array';
import {stringify} from '@republic/foundation/lang/json';
import {createPrefixed} from '@republic/foundation/storage';
import {stream} from '@republic/react-foundation';
import AuthStream from '../../auth/streams/AuthStream';
import session from '../../core/services/storage/session';
import {createRequestStream} from '../../core/streams';

export default (
    createRequestStream(
        'CancellationOffers',
        {
            code: 'account/cancellation-offers',
            error: 'A request for cancellation offers failed',
            enhance: (
                stream(
                    ['line'],
                    {
                        propTypes: {
                            line: PropTypes.string.isRequired
                        }
                    }))
        },
        createPrefixed(session, 'account/cancellation-offers/3.0', 15 * 60),
        {
            auth: AuthStream,
            line: ({line}) => line
        },
        ({auth, line}) => (
            (auth.state === AuthStream.states.authenticated && line) ?
                sha1(
                    stringify({
                        id: auth.id,
                        line
                    })) :
                null),
        offers => !!offers.data,
        () => true,
        ({auth, line}) => (
            auth.roles.rw_customer ?
                fetch(
                    updated(
                        '/fractus/p/stratus/rest/v3/offers',
                        {
                            offer_type: ['Return', 'Cancellation'],
                            service_line_uuid: line
                        }),
                    {
                        headers: {
                            Authorization: `Bearer ${auth.token}`
                        }
                    }) :
                    Promise.reject()),
        raw => ({
            raw,
            data: (
                reduce(
                    raw,
                    (offers, {offer_components: components, ref_id: id, type, target}) => {
                        if (type === 'Cancellation') {
                            return (
                                reduce(
                                    components,
                                    (offers, {offer_items: items}) => (
                                        reduce(
                                            items,
                                            (offers, {item: {product, sku}}) => {
                                                if (product === 'Relay') {
                                                    offers.push({
                                                        id,
                                                        sku,
                                                        line: target.service_line.uuid
                                                    });
                                                }
                                                return offers;
                                            },
                                            offers)),
                                    offers));
                        } else if (type === 'Return') {
                            return (
                                reduce(
                                    components,
                                    (offers, {offer_items: items}) => (
                                        reduce(
                                            items,
                                            (offers, {item: {product, sku}}) => {
                                                if (product === 'Relay') {
                                                    offers.push({
                                                        id,
                                                        sku
                                                    });
                                                }
                                                return offers;
                                            },
                                            offers)),
                                    offers));
                        } else {
                            return [];
                        }
                    },
                    []))
        }),
        () => ({raw: undefined, data: undefined})));
